import { Box3, Vector3 } from "three";

/** Fit all eight corners, including depth, inside a perspective viewport. */
export function frameBounds(bounds: Box3, direction: Vector3, fovDegrees: number, aspect: number, padding = 1.14) {
  const target = bounds.getCenter(new Vector3());
  const outward = direction.clone().normalize();
  const right = new Vector3(outward.z, 0, -outward.x).normalize();
  const up = new Vector3().crossVectors(outward, right).normalize();
  const tanVertical = Math.tan(fovDegrees * Math.PI / 360);
  const tanHorizontal = tanVertical * Math.max(0.1, aspect);
  let distance = 0.5;
  for (const x of [bounds.min.x, bounds.max.x]) {
    for (const y of [bounds.min.y, bounds.max.y]) {
      for (const z of [bounds.min.z, bounds.max.z]) {
        const corner = new Vector3(x, y, z).sub(target);
        const depth = corner.dot(outward);
        distance = Math.max(distance,
          depth + Math.abs(corner.dot(right)) * padding / tanHorizontal,
          depth + Math.abs(corner.dot(up)) * padding / tanVertical
        );
      }
    }
  }
  return { target, position: target.clone().addScaledVector(outward, distance) };
}
